<template>
  <header
    class="bg-surface-default-low border-static-default-low flex items-center border-b py-0"
  >
    <Logo
      class="text-static-default-hi my-4 ml-12 flex h-16"
      :disabled="isNotAllowedToLeave"
    />
  </header>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { CHECKOUT } from '../routes-names'

import Logo from './Logo.vue'

const route = useRoute()

const isNotAllowedToLeave = computed(() => route.name === CHECKOUT.PAYMENT)
</script>
